
import utils from '../../utils';
import ctor from './ctor';

const uuid = utils.uuid;
const WildEmitter = utils.WildEmitter;

const SignalClient = function(opts) {
    const that = this;

    const config = this.config = {
        signalServer: 'ws://127.0.0.1:8484',
        autoConnect: true
    };

    ctor.call(this, 'SignalClient', opts);

    this.wsCallbacks = {};
    
    this.on('*', function(name) {
        let method = 'on' + name.substr(0,1).toUpperCase() + name.substr(1);
        if (typeof(that[method]) === 'function') {
            let args = Array.prototype.slice.call(arguments, 1);
            that[method].apply(that, args);
        }
    });

    if (config.autoConnect) this.connect();
};

WildEmitter.mixin(SignalClient);

var pt = SignalClient.prototype;

pt.onConnect = function(sid) {
    this.sessionId = sid;
};

pt.onCreate = function(data, cb) {
    this.send('create', data, cb);
};

pt.onJoin = function(data, cb) {
    this.send('join', data, cb);
};

pt.onLeave = function(data, cb) {
    this.send('leave', data, cb);
};

pt.onShareScreen = function(data, cb) {
    this.send('shareScreen', data, cb);
};

pt.onUnshareScreen = function(data, cb) {
    this.send('unshareScreen', data, cb);
};

pt.onTrace = function(data, cb) {
    this.send('trace', data, cb);
};

pt.onMessage = function(d, cb) {
    //console.log('message', d, cb);
    if (d && !d.from) {
        //console.log('send:', d);
        this.send('message', d, cb);
    }
    else {
        //console.log('recv:', d);
    }
};

pt.send = function(eventName, data, cb) {
    const that = this;
    this.connect()
    .then(function() {
        that._send(eventName, data, cb);
    });
};

pt._send = function(eventName, data, cb) {
    let cbName;
    if (cb) {
        cbName = uuid();
        this.wsCallbacks[cbName] = (function() {
            delete this.wsCallbacks[cbName];
            cb.apply(this, arguments);
        }).bind(this);
    }
    let msg = {
        event: eventName,
        args: JSON.stringify(data),
        cb: cbName
    };
    let x = JSON.stringify(msg);
    this.ws.send(x);
};

pt.onRecv = function(data) {
    if (!this.ws) return;
    let d = JSON.parse(data);
    let args = [];
    if (d.data) {
        for(let i = 0; i < d.data.length; i++) {
            args.push(JSON.parse(d.data[i]));
        }
    }
    if (d.cb) {
        if (typeof(this.wsCallbacks[d.cb]) === 'function') {
            this.wsCallbacks[d.cb].apply(this, args);
        }
    }
    else if (d.event) {
        this.emit.apply(this, [d.event].concat(args));
    }
}

pt.getSessionid = function () {
    return this.sessionId;
};

pt.connect = function() {
    if (this.ws)
        return Promise.resolve(this.ws);
    else if (this.wsPromise)
        return this.wsPromise;
    else {
        const that = this;
        this.wsPromise = new Promise(function(resolve, reject) {
            that.$resolve = resolve;
            that.$reject = reject;
            that._connect(this);
        });
    }
    return this.wsPromise;
};

pt._connect = function(wsPromise) {
    let ws = this.ws = new WebSocket(this.config.signalServer);
    ws.binaryType = 'arraybuffer';

    this.sessionId = null;

    const that = this;

    const onmsg = function(e) {
        that.onRecv(e.data);
    };

    const onopen = function() {
        if (wsPromise && wsPromise.$resolve) {
            wsPromise.$resolve(this);
            delete wsPromise.$resolve;
            delete wsPromise.$reject;
        }
    };

    const onclose = function() {
        ws.removeEventListener('open', onopen);
        ws.removeEventListener('close', onclose);
        ws.removeEventListener('error', onerror);
        ws.removeEventListener('message', onmsg);
        that.ws = null;
        that.wsPromise = null;
        that.sessionId = null;
        that.emit('disconnect');
    };

    const onerror = function(e) {
        console.error(e);
        that.emit('error', e);
        if (wsPromise && wsPromise.$reject) {
            wsPromise.$reject(e);
            delete wsPromise.$resolve;
            delete wsPromise.$reject;
        }
    };

    ws.addEventListener('open', onopen);
    ws.addEventListener('close', onclose);
    ws.addEventListener('error', onerror);
    ws.addEventListener('message', onmsg);
};

pt.disconnect = function () {
    if (this.ws) {
        this.ws.close();
    }
};

export default SignalClient;
